export default __webpack_public_path__ + "scene2_4_bgcf14e7.png";